import { render } from "./appPageAchieve.vue?vue&type=template&id=8f5c7728&scoped=true"
import script from "./appPageAchieve.vue?vue&type=script&lang=js"
export * from "./appPageAchieve.vue?vue&type=script&lang=js"

import "./appPageAchieve.vue?vue&type=style&index=0&id=8f5c7728&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5c7728"]])

export default __exports__